import type { ProductSpec, SaleStatus } from '@/types';

export type { ShippingAddressFormValues } from '@/types';

export type DeliveryAddress = {
  id: number | null;
  fullName: string | null;
  kanaName: string | null;
  phone: string | null;
  zip: string | null;
  province: string | null;
  city: string | null;
  address1: string | null;
  address2: string | null;
};

export type DeliveryAddressCreateType = {
  id: number;
};

export type RegisterDeliveryAddressParams = {
  fullName: string;
  kanaName: string;
  phone: string;
  zip: string;
  province: string;
  city: string;
  address1: string;
  address2: string;
};

export type PurchaseHistoryProductMaterialItem = {
  materialId: number;
  materialName: string;
};

export type PurchaseHistoryProductItem = {
  id: number;
  workId: number;
  workName: string;
  productId: number;
  productName: string;
  productDescription: string;
  selectedColorId: number;
  selectedColorName: string;
  selectedSizeId: number;
  selectedSizeName: string;
  subOrderId: string;
  productColor: string;
  productSize: string;
  productDetail: string;
  printMethod: string;
  thumbnailUrl: string;
  previewImageUrl: string;
  basePrice: number;
  subtotal: number;
  discountedSubtotal: number;
  quantity: number;
  skuCode: string;
  materials: PurchaseHistoryProductMaterialItem[];
  prints: PurchaseHistoryProductPrintItem[];
  productSpecs: ProductSpec[];
  breakdownPrices: Record<string, number>;
  userPrintId: number;
  /** 販売ステータス */
  productSaleStatus: SaleStatus;
};

export type PurchaseHistoryProductPrintItem = {
  id: number;
  name: string;
  previewImageUrl: string;
  shareToken: string;
};

export type PurchaseHistoryListItem = {
  purchaseHistoryId: number;
  orderId: string;
  orderDate: string;
  estimatedDeliveryDate: string;
  userName: string;
  taxIncludedPrice: number;
  originalTaxIncludedPrice: number | null;
  discountAmount: number | null;
  totalAmount: number;
  shippingFee: number;
  originalShippingFee: number;
  paymentMethod: string;
  customerInfo: {
    fullName: string;
    kanaName: string;
    phone: string;
    zip: string;
    province: string;
    city: string;
    address1: string;
    address2: string;
  };
  deliveryStatus: string;
  latestStatus: string;
  trackingNumber: string;
  items: PurchaseHistoryProductItem[];
};

export type PurchaseHistoryDetailType = {
  purchaseHistoryId: number;
  orderId: string;
  orderDate: string;
  userName: string;
  taxIncludedPrice: number;
  originalTaxIncludedPrice: number | null;
  discountAmount: number | null;
  shippingFee: number;
  originalShippingFee: number;
  totalAmount: number;
  paymentMethod: string;
  customerInfo: {
    fullName: string;
    kanaName: string;
    phone: string;
    zip: string;
    province: string;
    city: string;
    address1: string;
    address2: string;
  };
  deliveryInfo: {
    deliveryStatus: string;
    estimatedDeliveryDate: string;
    trackingNumber: string;
  };
  items: PurchaseHistoryProductItem[];
  latestStatus: string;
};

export type ShueishaIdAuthParams = {
  oemServiceId: number;
  token: string;
  codeChallenge: string;
};

export type CardItem = {
  cardSeq: string;
  cardId: string;
  defaultFlag: boolean;
  cardNo: string;
  expiryMonth: string;
  expiryYear: string;
};

export type Veritrans4gCardList = {
  memberName: string;
  maxCardNum: number;
  mainCard: CardItem;
  subCard: CardItem[];
};

export enum ShueishaIdAuthType {
  auth = 'auth',
  changedEmail = 'changed_email',
  changedPassword = 'changed_password',
  withdrawal = 'withdrawal',
}
